import { render, staticRenderFns } from "./DashboardShop.vue?vue&type=template&id=1df774bf&scoped=true&"
import script from "./DashboardShop.vue?vue&type=script&lang=js&"
export * from "./DashboardShop.vue?vue&type=script&lang=js&"
import style0 from "./DashboardShop.vue?vue&type=style&index=0&id=1df774bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df774bf",
  null
  
)

export default component.exports